import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
    initCookieIns = new InitCookie({
        entry_channel: this.getEntryChannel(),
    });

    getEntryChannel() {
        return 'ip_detail_page';
    }

    async init() {
        return this.initCookieIns.init();
    }

    /**
     * 赋权接口的参数 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=272192900
     * @returns
     */
    getTrackingParams() {
        return {
            source: InitCookie.getCampaignName(),
            entryChannel: InitCookie.getEntryChannel(),
            productSource: 'eureka_ip',
        };
    }
}

export const initCookieService = new InitCookieService();
